import { render, staticRenderFns } from "./m-orm-reset-password-dialog.vue?vue&type=template&id=444040ac&lang=pug&"
import script from "./m-orm-reset-password-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-reset-password-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports